import omit from 'lodash/omit';

export default function patch(campaign, change) {
  const campaignLines = change.campaignLines.map(line => {
    const countryCode = line.country ? line.country.code : '';
    const productId = line.product.id;
    const adjustedFee = line.adjustedFee / 100;
    const originalFee = line.originalFee / 100;
    return omit({ ...line, countryCode, productId, adjustedFee, originalFee }, [
      'country',
      'product',
      'languages',
    ]);
  });

  const existingCampaignLines = campaign.campaignLineIds.map(id => ({ id }));

  return { campaignLines: campaignLines.concat(existingCampaignLines) };
}
